import * as amplitude from '@amplitude/analytics-browser'

export const initAmplitude = () => {
    if (process.env.REACT_APP_AMPLITUDE) {
        amplitude.init(process.env.REACT_APP_AMPLITUDE)
    }
}
const identifyInstance = new amplitude.Identify()

type accountType = 'partipost' | 'external'
export interface IdentifyState {
    accountTypes: accountType
    teams: string[]
    clientID: string
}
export const identifyEvent = (properties: IdentifyState) => {
    identifyInstance.set('account type', properties.accountTypes)
    identifyInstance.set('teams', properties.teams)
    identifyInstance.set('client ID', properties.clientID)
    amplitude.identify(identifyInstance)
}

interface propertiesType {
    [key: string]: string | number | string[]
}

export const traceEvent = (eventName: string, properties?: propertiesType) => {
    return amplitude.track(eventName, properties)
}

export const resetAnalytic = () => {
    return amplitude.reset()
}
